'use client';

import React, { useCallback } from 'react';
import { parseAsInteger, useQueryState } from 'nuqs';
import { Pagination } from '@mezzoforte/forge';
import { useSearchParams, usePathname } from 'next/navigation';

interface EntryListPaginationProps {
  readonly pageCount: number;
  readonly hideOnSinglePage?: boolean;
}

export function EntryListPagination({ pageCount, hideOnSinglePage }: EntryListPaginationProps) {
  const [queryPage, setQueryPage] = useQueryState('sivu', {
    ...parseAsInteger,
    shallow: false,
    scroll: true,
  });

  const searchParams = useSearchParams();
  const pathname = usePathname();

  const onPageChange = useCallback(
    (current: number) => {
      void setQueryPage(current);
    },
    [setQueryPage]
  );

  const generatePath = useCallback(
    (page: number) => {
      const params = new URLSearchParams(searchParams ?? undefined);
      params.set('sivu', page.toString());
      return `${pathname}?${params.toString()}`;
    },
    [searchParams, pathname]
  );

  return (
    <Pagination
      total={pageCount}
      current={queryPage ?? 1}
      onChange={onPageChange}
      hideOnSinglePage={hideOnSinglePage}
      generatePath={generatePath}
    />
  );
}
